document.addEventListener('DOMContentLoaded', function () {

  // 👉 在这里放你想修改文案的产品 handle 数组
  const specialProducts = [
    "viral-one-seam-shaping-fleece-leggings",
    "christmas-gift-box",
  ];

  // 当前产品 handle
  const currentHandle = window.location.pathname.split('/products/')[1];

  // 如果当前产品在你的指定列表中
  if (currentHandle && specialProducts.includes(currentHandle)) {
    const btn = document.querySelector('#product-add-to-cart');
    if (btn) {
      btn.textContent = "Buy Now";   // 👉 修改成你要的文案
    }
  }

});
// 修改产品页立即购买文案Buy Now 2025-12-09